module.exports = __webpack_public_path__ + "img/loading-quote-img-3.a9344372.png";